import { gql } from '@apollo/client';

export const listCatalogs = gql`
  query listCatalogs($pagination: PaginationInput, $filter: CatalogFilter) {
    listCatalogs(pagination: $pagination, filter: $filter) {
      id
      name {
        value
        languageCode
      }
      organization {
        id
        archived
        subscription {
          id
          status
        }
      }
    }
  }
`;
